import React, { useEffect, useMemo } from "react";
import { Select, Spin } from "antd";
import { useTranslation } from "react-i18next";
import { useLazyGetServiceListQuery } from "features/service/api/serviceListApi";

type Props = {
  value?: string[];
  onChange?: (value: string[]) => void;
  disabled?: boolean;
  placeholder?: string;
  size?: "large" | "middle" | "small";
  maxTagCount?: number | "responsive";
};

type ServiceRow = {
  code: string | number;
  nameRu?: string | null;
  nameKy?: string | null;
  deleted?: boolean;
};

const ServiceCodesSelect: React.FC<Props> = ({
  value = [],
  onChange,
  disabled,
  placeholder = "Выберите сервисы",
  size = "middle",
  maxTagCount = "responsive",
}) => {
  const { i18n } = useTranslation();
  const isKy = i18n.language?.startsWith("ky");

  const [fetchServices, { data: servicesData, isFetching }] =
    useLazyGetServiceListQuery();

  useEffect(() => {
    fetchServices({ page: 1, size: 200 });
  }, [fetchServices]);

  const rows: ServiceRow[] = servicesData?.res?.content ?? [];

  const options = useMemo(() => {
    return rows
      .filter((s) => s && s.code != null)
      .filter((s) => !s.deleted)
      .map((s) => {
        const code = String(s.code);
        const label = (isKy ? s.nameKy : s.nameRu) || code;
        return { value: code, label };
      });
  }, [rows, isKy]);

  const filterOption = (input: string, option?: any) => {
    const q = input.toLowerCase().trim();
    if (!q) return true;

    const label = String(option?.label ?? "").toLowerCase();
    const val = String(option?.value ?? "").toLowerCase();
    return label.includes(q) || val.includes(q);
  };

  return (
    <Select
      mode="multiple"
      showSearch
      allowClear
      value={value}
      onChange={(v) => onChange?.(v as string[])}
      options={options}
      placeholder={placeholder}
      disabled={disabled}
      size={size}
      maxTagCount={maxTagCount}
      filterOption={filterOption}
      notFoundContent={isFetching ? <Spin size="small" /> : "Ничего не найдено"}
      loading={isFetching}
    />
  );
};

export default ServiceCodesSelect;
